import { Team } from "@finway-group/shared/lib/models"
import axios from "axios"
import store from "Shared/store"

const MODEL = "teams"

const TeamService = {
    fetchTeams: async () => {
        const {
            data: { docs },
        } = await axios.get(`/${MODEL}?limit=100`)
        return docs as Team[]
    },
    updateAllTeams: async (updateData: Team[]) => {
        const { data } = await axios.put(`${MODEL}`, { teams: updateData })
        return data as Team[]
    },
    getTeamById: (id: string) => {
        const teams = store.getState().teams.items
        return teams.find((team: Team) => team._id === id)
    },
}

export default TeamService
